module.exports = __webpack_public_path__ + "img/footer (7).61683aa8.png";